import {inject} from 'vue'
import axios from "@vueform/vueform/src/services/axios";
import {Validator, date as VueformDate} from "@vueform/vueform";

const staticSelectsPlugin = {
    apply: 'SelectElement',
    props: {staticType: {required: false, type: String}},
    setup(props, context, component) {
        if (props.staticType === 'country') {
            let result = [];
            let hasAutoFill = false;
            component.resolvedOptions = async () => {
                let locale = inject('form$').value.locale$ || inject('config$').value.i18n.locale
                result = (await axios.get('/getcountries/'+locale)).data
                return result;
            }

            // Very dirty hack to handle autofill
            component.on('search-change', async (search, el$) => {
                window.setTimeout(() => {
                    if (hasAutoFill) {
                        const searchResult = result.find(country => country.label.toLowerCase() === search.toLowerCase());
                        if (searchResult) {
                            el$.update(searchResult.value);
                        }
                        el$.$refs.input.deactivate();
                    }
                },20)
            });
            document.addEventListener('animationstart', function(e) {
                if (e.animationName === 'autofill-detect') {
                    hasAutoFill = true;
                }
            });
        }
        return component;
    }
}

module.exports = {
    // Same guard as newform's dateValidator (see the long comment there): Vueform's
    // built-in `date` rule feeds the raw value into a strtotime port that starts with
    // `while (str.length)`, so an empty date field throws instead of validating and
    // takes the submit/step handler down with it. Sentry FEW-FRONTEND-VUE-6Z.
    dateValidator: class extends VueformDate {check(value) {
        if (value === null || value === undefined || value === '') {
            return true;
        }
        return super.check(value);
    }},
    phoneValidator: class extends Validator {check() {return !this.element$.invalid;}},
    emailValidator: class extends Validator {check() {
        if (!this.element$.model && !this.element$.rules.includes('required')) {
            return true
        }
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(this.element$.model).toLowerCase());
    }},
    staticSelectsPlugin,
}
